import * as React from 'react';
import { LANGUAGE_META } from 'src/utils/constants';
import { ReferenceEntity } from 'src/utils/reference-schema';
type Language = (typeof LANGUAGE_META)[number]['key'];

// Syntax to use when rendering code tokens
export type TypeDefinitionSyntax = 'array' // Ordered arrays
| 'class' // Classes
| 'list' // A list of parameters or return values
| 'map' // String maps in Go
| 'object'; // Generic objects

interface TypeDefinitionContextValue {
  entity: ReferenceEntity;
  language: Language;

  /** Variable or function declaration for this entity, e.g. "const myVariable" */
  declaration?: string;

  /** Whether to render expanded and unwrapped objects and arrays inline in key/type pairs */
  expanded?: boolean;

  /** Current indentation level */
  indent?: number;

  /** Variation of the syntax to render the tokens with */
  syntax?: TypeDefinitionSyntax;

  /** Whether to render tokens with urls as links */
  passHrefs?: boolean;
}
export const TypeDefinitionContext = React.createContext<TypeDefinitionContextValue | null>(null);
export function useTypeDefinition() {
  const context = React.useContext(TypeDefinitionContext);
  if (context === null) {
    throw new Error('Missing type definition context value.');
  }
  return context;
}